const Quarta = () => {
  return (
    <div
      className="
            mx-10 flex flex-row items-center text-preto space-x-5 mt-28
            sm:mx-10 sm:space-x-5 
            md:mx-10 md:space-x-10
            lg:mx-28 lg:space-x-10
            xl:mx-28 xl:space-x-10
            2xl:mx-28 2xl:space-x-10
            "
    >
      <h1
        className="
                font-poppins font-bold text-xl
                sm:text-xl
                md:text-2xl
                lg:text-3xl
                xl:text-3xl
                2xl:text-3xl
                "
      >
        PRODUTOS
      </h1>
      <div className="bg-[#1E1E1E] h-[2px] rounded-md w-full" />
    </div>
  );
};
export default Quarta;
